import React from 'react'
import { useFileUrl } from '../functions/FileUrlContext'
import { youtubeEmbedUrl } from '../functions/youtubeEmbedUrl'
import { LABELS } from '../constants/staticText'
import { bildMasse } from '../../lib/functions/bildMasse'

// Bildleiste der Anzeige zwischen den Knoepfen und dem Text, wie auf der
// Live-Seite (.job_img_cont): Fotos, hochgeladenes und YouTube-Video nebeneinander, ein
// einzelnes Element steht mit halber Breite neben dem Text (#210, #211).
// Die Fotos sind Schmuck (alt=""): der Dateiname war kein Text fuer den
// Screenreader (Audit 2026-10-07, B4).
const JobMedia = ({ media }) => {
    const fileUrl = useFileUrl()
    const photos = (media && media.photos) || []
    const video = youtubeEmbedUrl(media && media.video)
    // Hochgeladenes Video (#237) neben dem YouTube-Link.
    const videoFile = media && media.videoFile
    const anzahl = photos.length + (video ? 1 : 0) + (videoFile ? 1 : 0)
    if (0 === anzahl) return null

    return (
        <div className={`job-detail-media ${1 === anzahl ? 'is-one' : 'is-many'}`} data-testid="job-detail-media">
            {photos.map(photo => (
                <img key={photo.fileId} src={fileUrl(photo.fileId)} alt="" loading="lazy" decoding="async" {...bildMasse(photo)} />
            ))}
            {videoFile && (
                <video src={fileUrl(videoFile.fileId)} controls preload="metadata" title={LABELS.videoTitle} />
            )}
            {video && (
                <iframe
                    src={video}
                    title={LABELS.videoTitle}
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                />
            )}
        </div>
    )
}

export default JobMedia
